(() => {
  const wishlistKey = 'memorra:wishlist:v1';
  const recentKey = 'memorra:recent:v1';
  const migrationKey = 'memorra:wishlist:migrated:v1';
  const validHandle = value => typeof value === 'string' && /^[a-z0-9-]{1,120}$/.test(value);
  const getJSON = (key, fallback) => {
    try { const value = JSON.parse(localStorage.getItem(key)); return Array.isArray(value) ? value : fallback; }
    catch (_) { return fallback; }
  };
  const setJSON = (key, value) => {
    try { localStorage.setItem(key, JSON.stringify(value)); return true; }
    catch (_) { return false; }
  };
  const clean = values => values.filter(item => item && validHandle(item.handle)).filter((item, i, array) => array.findIndex(other => other.handle === item.handle) === i).slice(0, 50);
  const migrate = () => {
    try { if (localStorage.getItem(migrationKey) === 'true') return; } catch (_) { return; }
    const items = clean(getJSON(wishlistKey, []));
    try {
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (!key || !key.startsWith('memorra-wishlist-') || localStorage.getItem(key) !== 'true') continue;
        const handle = key.slice('memorra-wishlist-'.length);
        if (validHandle(handle) && !items.some(item => item.handle === handle)) items.push({ handle });
      }
      if (items.length) setJSON(wishlistKey, clean(items));
      localStorage.setItem(migrationKey, 'true');
    } catch (_) {}
  };
  migrate();
  const getWishlist = () => clean(getJSON(wishlistKey, []));
  const getRecent = () => clean(getJSON(recentKey, [])).slice(0, 20);
  const formatPrice = cents => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(Number(cents) / 100);
  const notify = message => {
    let toast = document.getElementById('memorra-wishlist-toast');
    if (!toast) {
      toast = document.createElement('div'); toast.id = 'memorra-wishlist-toast'; toast.setAttribute('role', 'status');
      toast.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);z-index:9999;background:#4A0E4E;color:#fff;padding:11px 18px;border-radius:7px;font:500 14px Arial,sans-serif;box-shadow:0 6px 22px #0003;pointer-events:none;opacity:0;transition:opacity .2s;';
      document.body.appendChild(toast);
    }
    toast.textContent = message; toast.style.opacity = '1';
    clearTimeout(notify.timer); notify.timer = setTimeout(() => { toast.style.opacity = '0'; }, 2800);
  };
  const sync = () => {
    const items = getWishlist();
    document.querySelectorAll('[data-memorra-wishlist-count]').forEach(node => { node.textContent = String(items.length); node.hidden = !items.length; });
    document.querySelectorAll('[data-memorra-wishlist-link]').forEach(node => node.setAttribute('aria-label', `Wishlist, ${items.length} saved ${items.length === 1 ? 'product' : 'products'}`));
    document.querySelectorAll('[data-memorra-wishlist-toggle]').forEach(node => {
      const saved = items.some(item => item.handle === node.dataset.handle);
      node.setAttribute('aria-pressed', String(saved));
      node.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Add to wishlist');
      node.dataset.wishlistLabel = saved ? 'Remove from wishlist' : 'Add to wishlist';
    });
    document.dispatchEvent(new CustomEvent('memorra:wishlist-change'));
  };
  const toggle = button => {
    const handle = button.dataset.handle;
    if (!validHandle(handle)) return;
    const items = getWishlist();
    const index = items.findIndex(item => item.handle === handle);
    if (index >= 0) { items.splice(index, 1); notify('Removed from wishlist'); }
    else { items.unshift({ handle, personalized: button.dataset.personalized === 'true' }); notify('Added to wishlist'); }
    if (!setJSON(wishlistKey, clean(items))) { notify('Wishlist could not be saved in this browser'); return; }
    sync();
    button.classList.add('is-feedback');
    clearTimeout(button.wishlistFeedbackTimer);
    button.wishlistFeedbackTimer = setTimeout(() => button.classList.remove('is-feedback'), 1500);
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-memorra-wishlist-toggle]');
    if (button) { event.preventDefault(); event.stopPropagation(); toggle(button); }
  });
  window.addEventListener('storage', event => { if (event.key === wishlistKey) sync(); });
  const initRecent = () => {
    const productButton = document.querySelector('.custom-wishlist-btn[data-handle]');
    if (!productButton) return;
    const handle = productButton.dataset.handle;
    if (!validHandle(handle)) return;
    setJSON(recentKey, clean([{ handle, personalized: productButton.dataset.personalized === 'true' }, ...getRecent()]).slice(0, 20));
  };
  const productCache = new Map();
  const getProduct = handle => {
    if (!productCache.has(handle)) productCache.set(handle, fetch(`/products/${encodeURIComponent(handle)}?view=memorra-card`, { credentials: 'same-origin' }).then(async response => {
      if (!response.ok) return null;
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const data = doc.querySelector('[data-memorra-card-data]');
      const card = doc.querySelector('.memorra-product-card');
      if (!data || !card) return null;
      const product = JSON.parse(data.textContent);
      product.cardMarkup = card.outerHTML;
      return product;
    }).catch(() => null));
    return productCache.get(handle);
  };
  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  };
  const renderCard = (entry, product, mode, shared) => {
    const doc = new DOMParser().parseFromString(product.cardMarkup, 'text/html');
    const card = document.importNode(doc.querySelector('.memorra-product-card'), true);
    card.classList.add('mw-card');
    const href = card.querySelector('.me-card__image').getAttribute('href');
    const toggle = card.querySelector('[data-memorra-wishlist-toggle]');
    const saved = getWishlist().some(item => item.handle === entry.handle);
    toggle.setAttribute('aria-pressed', String(saved));
    toggle.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Add to wishlist');
    const actions = element('div', 'me-card__quickadd');
    const needsName = entry.personalized !== false || (Array.isArray(product.tags) && product.tags.some(tag => String(tag).toLowerCase().includes('personalized')));
    if (mode === 'wishlist' && !shared && !needsName && product.available && product.variants && product.variants.length) {
      const add = element('button', 'me-button me-card__button', 'Move to cart'); add.type = 'button';
      add.addEventListener('click', async () => {
        add.disabled = true; add.textContent = 'Adding…';
        try {
          const variant = product.variants.find(v => v.available) || product.variants[0];
          const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }) });
          if (!response.ok) throw new Error('Could not add to cart');
          setJSON(wishlistKey, getWishlist().filter(item => item.handle !== entry.handle));
          await window.memorraCommerce.openCart();
        } catch (_) { add.disabled = false; add.textContent = 'Move to cart'; notify('Could not add this item. Please open its product page.'); }
      });
      actions.appendChild(add);
      card.querySelector('.me-card__button').replaceWith(actions);
    } else {
      // The shared server-rendered link keeps the same product and couple routing.
    }
    return card;
  };
  const initPage = () => {
    const page = document.querySelector('[data-memorra-wishlist-page]');
    if (!page) return;
    const grid = page.querySelector('[data-mw-grid]');
    const empty = page.querySelector('[data-mw-empty]');
    const emptyMessage = page.querySelector('[data-mw-empty-message]');
    const loading = page.querySelector('[data-mw-loading]');
    const share = page.querySelector('[data-mw-share]');
    const tabs = Array.from(page.querySelectorAll('[data-mw-tab]'));
    const sharedHandles = new URLSearchParams(location.search).get('wishlist');
    const shared = sharedHandles !== null;
    const sharedEntries = shared ? clean(sharedHandles.split(',').map(handle => ({ handle }))) : [];
    let currentTab = 'wishlist'; let renderId = 0;
    const render = async () => {
      const id = ++renderId;
      const entries = shared && currentTab === 'wishlist' ? sharedEntries : currentTab === 'wishlist' ? getWishlist() : getRecent();
      grid.replaceChildren(); empty.hidden = true; loading.hidden = !entries.length;
      share.hidden = currentTab !== 'wishlist' || !entries.length;
      if (!entries.length) { empty.hidden = false; emptyMessage.textContent = currentTab === 'recent' ? 'Your recently viewed pieces will appear here.' : 'Your wishlist is waiting for a piece you love.'; return; }
      const rows = await Promise.all(entries.map(async entry => ({ entry, product: await getProduct(entry.handle) })));
      if (id !== renderId) return;
      loading.hidden = true;
      rows.forEach(({ entry, product }) => { if (product) grid.appendChild(renderCard(entry, product, currentTab, shared && currentTab === 'wishlist')); });
      if (!grid.children.length) { empty.hidden = false; emptyMessage.textContent = 'These pieces are no longer available. Explore our collection for something new.'; }
    };
    tabs.forEach(tab => tab.addEventListener('click', () => {
      currentTab = tab.dataset.mwTab;
      tabs.forEach(button => { const active = button === tab; button.setAttribute('aria-selected', String(active)); button.tabIndex = active ? 0 : -1; });
      render();
    }));
    share.addEventListener('click', async () => {
      const handles = (shared ? sharedEntries : getWishlist()).map(item => item.handle);
      const url = new URL('/pages/wishlist', location.origin); url.searchParams.set('wishlist', handles.join(','));
      try {
        if (navigator.share) await navigator.share({ title: 'Memorra wishlist', url: url.href });
        else if (navigator.clipboard) { await navigator.clipboard.writeText(url.href); notify('Wishlist link copied'); }
        else { window.prompt('Copy wishlist link', url.href); }
      } catch (_) {}
    });
    document.addEventListener('memorra:wishlist-change', () => { if (!shared && currentTab === 'wishlist') render(); });
    if (shared) page.querySelector('[data-mw-heading]').textContent = 'Shared wishlist';
    render();
  };
  const start = () => { initRecent(); sync(); initPage(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();
